import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface FacebookPage {
  id: string;
  name: string;
  category?: string;
  followers?: number;
  category_list?: Array<{
    id: string;
    name: string;
  }>;
  about?: string;
  link?: string;
  phone?: string;
  emails?: string[];
  cover?: {
    cover_id: string;
    offset_x: number;
    offset_y: number;
    source: string;
    id: string;
  };
  picture?: {
    data: {
      url: string;
    };
  };
  fan_count?: number;
  followers_count?: number;
  verification_status?: string;
  is_verified?: boolean;
}

interface FacebookPagesState {
  pages: FacebookPage[];
  loading: boolean;
  error: string | null;
  selectedPageId: string | null;
}

const initialState: FacebookPagesState = {
  pages: [],
  loading: false,
  error: null,
  selectedPageId: null,
};

const facebookPagesSlice = createSlice({
  name: 'facebookPages',
  initialState,
  reducers: {
    fetchFacebookPagesRequest: (state, action: PayloadAction<{ integrationId: string }>) => {
      state.loading = true;
      state.error = null;
    },
    fetchFacebookPagesSuccess: (state, action: PayloadAction<FacebookPage[]>) => {
      state.loading = false;
      state.pages = action.payload;
      state.error = null;
    },
    fetchFacebookPagesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedPage: (state, action: PayloadAction<string>) => {
      state.selectedPageId = action.payload;
    },
    updatePageRequest: (state, action: PayloadAction<{ integrationId: string; pageId: string; platform: string }>) => {
      state.loading = true;
      state.error = null;
    },
    updatePageSuccess: (state, action: PayloadAction<FacebookPage>) => {
      state.selectedPageId = action.payload.id;
      state.loading = false;
      state.error = null;
      // Update the page in the list if it exists
      const pageIndex = state.pages.findIndex(p => p.id === action.payload.id);
      if (pageIndex !== -1) {
        state.pages[pageIndex] = action.payload;
      }
    },
    updatePageFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearFacebookPages: (state) => {
      state.pages = [];
      state.loading = false;
      state.error = null;
      state.selectedPageId = null;
    },
  },
});

export const {
  fetchFacebookPagesRequest,
  fetchFacebookPagesSuccess,
  fetchFacebookPagesFailure,
  setSelectedPage,
  updatePageRequest,
  updatePageSuccess,
  updatePageFailure,
  clearFacebookPages,
} = facebookPagesSlice.actions;

export default facebookPagesSlice.reducer;
